// extracted by mini-css-extract-plugin
export default {"star_rating_container_container":"star-rating-container_star_rating_container_container__TKEpA"};